module.exports = __webpack_public_path__ + "static/Muli-Regular-aae50cb40468371ec64eb70d1a50fba8.woff";